export const DIMENSION_CATEGORY_KEYS = {
  eco: {
    content: 'content',
    user: 'user',
    device: 'device',
    geo: 'geo',
    screen: 'screen',
    events: 'events',
    network: 'network',
    errors: 'errors',
    page: 'page',
    event_tags: 'event_tags',
    global_tags: 'global_tags',
  },
};

export const dimensionsCategory = {
  EI: {
    content: 'Content', // represents both common and ei dimensions
    ai: 'Ad',
    geo: 'Geo',
    device: 'Device',
  },
  AI: {
    ai: 'Ad',
    geo: 'Geo',
    device: 'Device',
  },
  APP: {
    content: 'App',
    user: 'User',
    device: 'Device',
    geo: 'Geo & ISP',
    screen: 'Screen (Mobile)',
    [DIMENSION_CATEGORY_KEYS.eco.network]: 'Network Request',
    [DIMENSION_CATEGORY_KEYS.eco.events]: 'Events',
    errors: 'Errors',
    page: 'Page (Web)',
    // custom: 'Custom',
    event_tags: 'Event Tags',
    global_tags: 'Global Tags',
  },
  ODP: {
    custom: 'Custom',
  },
  ECO_SERVER: {
    content: 'Content',
    device: 'Device',
    geo: 'Geo',
    screen: 'Screen (Mobile)',
    network: 'Network Request',
    events: 'Events',
    errors: 'Errors',
    page: 'Page (Web)',
    span: 'Span',
    custom: 'Custom',
  },
};

export const dimensionsCategoryOrder = {
  EI: ['content', 'device', 'geo', 'ai'],
  AI: ['ai', 'device', 'geo'],
  APP: [
    'content',
    'user',
    'device',
    'geo',
    'page',
    'screen',
    'network',
    'events',
    'errors',
    'global_tags',
    'event_tags',
  ],
  ODP: ['custom'],
  ECO_SERVER: [
    'content',
    'device',
    'geo',
    'page',
    'screen',
    'network',
    'events',
    'span',
    'errors',
    'custom',
  ],
};
